import { Button } from "components/Button"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { PlusCircle } from "components/Icon"
import { ProfilePage } from "components/ProfilePage"
import { useRouter } from "components/Router"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { BoatCard } from "domains/boat/BoatCard"
import * as React from "react"

export function AccountBoatIndexPage({
  boats: boatsProps,
  user,
  tabs = window.accountNav,
  infos,
}) {
  const translator = useTranslator()
  const router = useRouter()
  const connectedUser = useConnectedUser()
  const [boats, setBoats] = React.useState(boatsProps)

  const handleDeleteBoat = (deletedBoat) => {
    setBoats((prevBoats) =>
      prevBoats.filter((boat) => boat.id !== deletedBoat.id),
    )
  }

  const isOwnProfile = connectedUser?.id === user.id
  const isAdmin = connectedUser?.roles.includes("ROLE_ADMIN")

  const extraActions = [
    isOwnProfile || isAdmin ? (
      <Button
        key="add-boat"
        href={
          connectedUser?.id === user.id
            ? router.generate("app_user_boat_add")
            : router.generate("app_user_boat_add", { userId: user.id })
        }
        iconLeft={<PlusCircle className="w-4" />}
        fullWidth
      >
        {translator.trans("account.boat.index.add", null, "pages")}
      </Button>
    ) : null,
  ].filter(Boolean)

  return (
    <ProfilePage
      user={user}
      tabs={tabs}
      infos={infos}
      extraActions={extraActions}
    >
      {boats.length > 0 ? (
        <div className="grid gap-4 md:grid-cols-2">
          {boats.map((boat) => {
            return (
              <BoatCard
                key={boat.id}
                boat={boat}
                ownerId={user.id}
                onDelete={handleDeleteBoat}
              />
            )
          })}
        </div>
      ) : (
        <Text tag="p">
          {translator.trans("account.boat.index.empty.message", null, "pages")}
        </Text>
      )}
    </ProfilePage>
  )
}
